import { Container, Row, Col } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import baseUrl from "../../utilities/baseUrl";

function SuccessPage() {
  const [searchParams] = useSearchParams();

  const numberParcel = searchParams.get("numberParcel");

  if (!numberParcel) return <Navigate to="/" />;

  return (
    <div className="bg-suces-style">
      <Container className="pt-5">
        <Row className="d-flex align-items-center justify-content-center bg-white mt-5">
          <Col className="d-flex align-items-center justify-content-center clmn-style m-5">
            <div
              className="border border-secondary rounded-circle
                    d-flex align-items-center justify-content-center"
            >
              <Check color="green" size={60} />
            </div>
            <h3 className="mt-3 text-success">تراکنش موفق </h3>
            <p>تراکنش با موفقیت انجام شد</p>
          </Col>
        </Row>

        <div className="d-flex align-items-center justify-content-center mt-3">
          <Link to="/" className="btn btn-secondary mx-1">
            صفحه اصلی
          </Link>
          <Link
            className="btn btn-primary"
            to={`${baseUrl}/external-post/v1/factor?numberParcel=${numberParcel}`}
            target="_blank"
            rel="noreferrer"
          >
            پرینت فاکتور
          </Link>
        </div>
      </Container>
    </div>
  );
}

export default SuccessPage;
